import { Box } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { KeyDriveBodyMin } from "./Fonts/Body/KeyDriveBodyMin";
import { EventAvailable, EventBusy, Today } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export type TemporalityStatusType = "near" | "expired" | "ok";

export interface KeyDriveTemporalityStatusProps {
  status: TemporalityStatusType;
}

const KeydriveDeadline = ({
  status,
}: KeyDriveTemporalityStatusProps) => {

  const { t } = useTranslation();

  const statusConfig: Record<TemporalityStatusType, { label: string; color: string; bgColor: string; borderColor: string }> = {
    near: {
      label: t("Temporality.DeadlineOptions.NearDeadline"),
      color: "#E6A817",
      bgColor: "#FFF4E0",
      borderColor: "#E6A817",
    },
    expired: {
      label: t("Temporality.DeadlineOptions.AboveDeadline"),
      color: "#D32F2F",
      bgColor: "#FDECEA",
      borderColor: "#D32F2F",
    },
    ok: {
      label: t("Temporality.DeadlineOptions.BelowDeadline"),
      color: "#2E7D32",
      bgColor: "#EDF7EE",
      borderColor: "#2E7D32",
    },
  };

    const config = statusConfig[status];

    function statusIconHandler() {
        if (status === "ok") {
            return <EventAvailable 
                        sx={{ fontSize: 20, color: config.color }}
                    />
        } else if (status == "expired") {
            return <EventBusy 
                        sx={{ fontSize: 20, color: config.color }}
                    />
        } else if (status == "near") {
            return <Today 
                        sx={{ fontSize: 20, color: config.color }}
                    />
        }
    }

    return (
        <Box
            display="inline-flex"
            alignItems="center"
            gap="6px"
            padding="4px 10px"
            width="fit-content"
        >
            
            { statusIconHandler() }
            <KeyDriveBodyMin
                text={config.label}
                color="#2b2b2b"
                needBold={false}
                needEllipses={false}
            />
        </Box>
    );
};

export default KeydriveDeadline;